import { FC } from 'react';

import Wrapper, { SecureCardDescription } from './Wrapper';

export type SecureCardProps = { sslId: string };

const ICON_SRC =
  'https://wwwsslcom.a.cdnify.io/assets/ssl_seal_1-3dfcdf69a9e544495dbcf366a74ee5c4baca7e4f8018f7ddfa22f2de9bcf464d.png';

const getHref = (id: string) => {
  if (!isSSLIdValid(id)) throw new Error(`SSL id: ${id} is NOT valid`);
  return `https://www.ssl.com/team/a3d-1b33o49/site_seals/${id}/site_report`;
};

const isSSLIdValid = (code: string) =>
  code.split('-').every(codePart => codePart.length === 8);

const SecureCard: FC<SecureCardProps> = ({ sslId }) => (
  <Wrapper>
    <a href={getHref(sslId)} target="blank">
      <img src={ICON_SRC} alt="Ssl seal 1" width="60" />
    </a>
    <SecureCardDescription>Secure credit card payment</SecureCardDescription>
  </Wrapper>
);

export default SecureCard;
